// Central data-testid registry for the site.
export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkPrestazioni: "nav-link-prestazioni",
  linkPatologie: "nav-link-patologie",
  linkChiSono: "nav-link-chi-sono",
  linkBlog: "nav-link-blog",
  linkContatti: "nav-link-contatti",
  ctaBook: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  ctaBook: "hero-cta-book",
  ctaWhatsapp: "hero-cta-whatsapp",
};

export const HOME = {
  emergentLink: "home-emergent-link",
  patologiaCard: (slug) => `patologia-card-${slug}`,
  prestazioneCard: (slug) => `prestazione-card-${slug}`,
  reviewCard: (i) => `review-card-${i}`,
  locationCard: (city) => `location-card-${city.toLowerCase()}`,
  locationMaps: (city) => `location-maps-${city.toLowerCase()}`,
  faqTrigger: (i) => `faq-trigger-${i}`,
  ctaFinalBook: "cta-final-book",
};

export const FOOTER = {
  root: "footer-root",
  whatsapp: "footer-whatsapp",
  email: "footer-email",
  book: "footer-book",
};

export const BLOG = {
  list: "blog-list",
  card: (slug) => `blog-card-${slug}`,
  post: "blog-post",
};

export const CONDITION = {
  root: (slug) => `condition-page-${slug}`,
  ctaBook: "condition-cta-book",
};

export const SERVICE = {
  root: (slug) => `service-page-${slug}`,
  ctaBook: "service-cta-book",
};
